import { AppLayout } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { EventsNav } from '@src/components/sco/Events/EventsLayout/EventsNav.tsx';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import React, { useMemo } from 'react';
type EventsLayoutProps = {
  asidePanel?: ReactNode;
  mainPanel?: ReactNode;
  navPanel?: ReactNode;
};
export const EventsLayout = (props: EventsLayoutProps) => {
  const pathname = usePathname();
  const panels: AppLayoutPanelProps[] = useMemo(() => [{
    id: 'events-nav',
    useDrawerBreakpoints: {
      base: true,
      md: false
    },
    isResizable: true,
    resizeHandlePosition: 'right',
    defaultWidth: 280,
    children: props.navPanel ? props.navPanel : <EventsNav />,
    isPanelOpen: true,
    isDrawerOpen: false
  }, {
    id: 'events-main',
    children: props.mainPanel,
    isPanelOpen: true,
    isDrawerOpen: true
  }, {
    id: 'events-aside',
    useDrawerBreakpoints: {
      base: true,
      lg: false
    },
    isResizable: true,
    resizeHandlePosition: 'left',
    drawerPlacement: 'right',
    defaultWidth: 400,
    children: props.asidePanel,
    isPanelOpen: false,
    isDrawerOpen: false
  }], [pathname, props.mainPanel, props.asidePanel]);
  return <AppLayout header={<ScoSiteNavBar />} id={'events-layout'} panels={panels} />;
};
export const EventsPage = Component => {
  Component.getLayout = (page: React.ReactElement) => {
    return <EventsLayout mainPanel={page} />;
  };
  return Component;
};